import { Model } from 'app/model/backendmodel';
import { ActivityPolicy } from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { stringIsNullOrWhitespace } from 'app/shared/utils/string.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ActivityPolicy),
    adapts: {
        timeout: '*'
    }
})
export class ActivityPolicyAdapter {
    public toResource(activityPolicy: ActivityPolicy): Model.ActivityPolicy {
        const modelActivityPolicy: Model.ActivityPolicy = {
            timeout: activityPolicy.timeout,
            retry: activityPolicy.retry,
            retryIntervalInSeconds: activityPolicy.retryIntervalInSeconds,
            secureOutput: activityPolicy.secureOutput,
            secureInput: activityPolicy.secureInput
        };

        const rc = activityPolicy.retryConditions;
        if (rc?.type === 'Expression' && !stringIsNullOrWhitespace(rc.value)) {
            modelActivityPolicy.retryConditions = { type: 'Expression', value: rc.value };
        }

        if (activityPolicy.exponentialRetry) {
            modelActivityPolicy.exponentialRetry = activityPolicy.exponentialRetry;
        }
        if (activityPolicy.maxRetryIntervalInSeconds !== undefined) {
            modelActivityPolicy.maxRetryIntervalInSeconds = activityPolicy.maxRetryIntervalInSeconds;
        }

        return modelActivityPolicy;
    }

    public toModel(modelActivityPolicy: Model.ActivityPolicy): ActivityPolicy {
        const activityPolicy: ActivityPolicy = new ActivityPolicy();

        activityPolicy.retry = modelActivityPolicy.retry;
        activityPolicy.timeout = modelActivityPolicy.timeout;
        activityPolicy.retryIntervalInSeconds = modelActivityPolicy.retryIntervalInSeconds || activityPolicy.retryIntervalInSeconds;

        if (activityPolicy.retryIntervalInSeconds < 30) {
            activityPolicy.retryIntervalInSeconds = 30;
        }

        activityPolicy.secureOutput = modelActivityPolicy.secureOutput;
        activityPolicy.secureInput = modelActivityPolicy.secureInput;
        
        const rc = modelActivityPolicy.retryConditions;
        activityPolicy.retryConditions = rc?.type === 'Expression' && !stringIsNullOrWhitespace(rc.value)
            ? { type: 'Expression', value: rc.value }
            : undefined;

        activityPolicy.exponentialRetry = modelActivityPolicy.exponentialRetry;
        activityPolicy.maxRetryIntervalInSeconds = modelActivityPolicy.maxRetryIntervalInSeconds;

        return activityPolicy;
    }

    public toModelWhenNull(): ActivityPolicy {
        const activityPolicy: ActivityPolicy = new ActivityPolicy();

        activityPolicy.timeout = undefined;

        return activityPolicy;

    }
}
